module.exports = __webpack_public_path__ + "b707edebf927eb25a0cf2c907ac77731.png";